module.exports = __webpack_public_path__ + "static/media/correct_ans_1.a7fd5fef.png";